import { getRequest, postRequest, getcontractIdNumber } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = `${searchTerm}, ContractID:${getcontractIdNumber()},`
  return getRequest(
    `address/get-list/${size || 15}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`,
  )
}

export async function find(id) {
  return getRequest(`address/edit/${id}`)
}

export async function save(values) {
  return postRequest(`address/save`, values)
}

export function remove(values) {
  return postRequest(`address/delete`, values)
}
